"use strict";
/******** PALETTE OF COLORS ********/
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediumYellow = exports.lightYellow = exports.mediumRed = exports.lightRed = exports.lightGrey = exports.darkMediumGrey = exports.darkerGrey = exports.mediumGreen = exports.darkGreen = exports.lightLightBlue = exports.mediumBlue = exports.mediumLightBlue = exports.lightBlue = exports.darkGreenBlue = exports.darkBlue = exports.darkMediumBlue = exports.white = void 0;
// White
exports.white = '#ffffff';
// Blues
exports.darkMediumBlue = '#56808e';
exports.darkBlue = '#0f3e4d';
exports.darkGreenBlue = '#00222d';
exports.lightBlue = '#ebf2fa';
exports.mediumLightBlue = '#92adcc';
exports.mediumBlue = '#3493e7';
exports.lightLightBlue = '#f7fafd';
// Greens
exports.darkGreen = '#4e7d10';
exports.mediumGreen = '#8fce3d';
// Grey
exports.darkerGrey = '#222';
exports.darkMediumGrey = '#506f78';
exports.lightGrey = '#d7dee9';
//Reds
exports.lightRed = '#ef6474';
exports.mediumRed = '#e6112b';
// Yellows
exports.lightYellow = '#ffdb6c';
exports.mediumYellow = '#ffce38';
